/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoMnLnbDetailRequest model module.
 * @module model/SystemControllerDtoMnLnbDetailRequest
 * @version 1.0
 */
class SystemControllerDtoMnLnbDetailRequest {
    /**
     * Constructs a new <code>SystemControllerDtoMnLnbDetailRequest</code>.
     * @alias module:model/SystemControllerDtoMnLnbDetailRequest
     * @param lnbNo {Number} 
     */
    constructor(lnbNo) { 
        
        SystemControllerDtoMnLnbDetailRequest.initialize(this, lnbNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, lnbNo) { 
        obj['lnbNo'] = lnbNo;
    }

    /**
     * Constructs a <code>SystemControllerDtoMnLnbDetailRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoMnLnbDetailRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoMnLnbDetailRequest} The populated <code>SystemControllerDtoMnLnbDetailRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoMnLnbDetailRequest();

            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoMnLnbDetailRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoMnLnbDetailRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoMnLnbDetailRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

SystemControllerDtoMnLnbDetailRequest.RequiredProperties = ["lnbNo"];

/**
 * @member {Number} lnbNo
 */
SystemControllerDtoMnLnbDetailRequest.prototype['lnbNo'] = undefined;






export default SystemControllerDtoMnLnbDetailRequest;

